import { useEffect } from "react";
import { SITE } from "../config/site";

const upsertMeta = (selector, attrs) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement("meta");
    const [key, val] = selector.replace(/[[\]'"]/g, "").split("=");
    el.setAttribute(key, val);
    document.head.appendChild(el);
  }
  Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
};

export default function SEO({ title, description, path = "/" }) {
  useEffect(() => {
    document.title = title;
    const url = `${SITE.domain}${path}`;
    upsertMeta("meta[name='description']", { content: description });
    upsertMeta("meta[property='og:title']", { content: title });
    upsertMeta("meta[property='og:description']", { content: description });
    upsertMeta("meta[property='og:url']", { content: url });
    upsertMeta("meta[name='twitter:title']", { content: title });
    upsertMeta("meta[name='twitter:description']", { content: description });
    let canonical = document.head.querySelector("link[rel='canonical']");
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", url);
  }, [title, description, path]);
  return null;
}
